import type { FaireProductEntity } from "../../entity_types/product";

export const p_r8g7tqfdwj: FaireProductEntity = {
  token: "p_r8g7tqfdwj",
  type: "product",
  name: "Retro print on cashmere blend scarf finished with fringes",
  brandToken: "b_170ux74pv6",
  brandName: "London Scarves",
  imageUrl:
    "https://cdn.faire.com/fastly/c64baced03d1799d05ea9436ecd48d383a8a8135e6f37ab214a33d5e955113b7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/986d2b67edeccb3a960d264b050629432081bc62b4af6de87c2efaca5d26986a.jpeg",
    "https://cdn.faire.com/fastly/7c922e1f12493d4b0385cce70f20167326e418782f6a661078e9b6ac7905b381.jpeg",
    "https://cdn.faire.com/fastly/dab03bc6f3a0805c58e12d9bd11063bc8e440b6690d3526a8dccc75764cdf562.jpeg",
    "https://cdn.faire.com/fastly/4c3d63eef591f69e30e0de56ada8af0336f7f18e08d5e970a46875dbd172f8fe.jpeg",
    "https://cdn.faire.com/fastly/391499af20b1ff935bd872305265e1bae69904c0621b62ce3b7ca58ebcf52bed.jpeg",
    "https://cdn.faire.com/fastly/c2b8c3824ecfdc9a7ea36ab16e30a827230b628809c30ac58720f7e51a8c9a97.jpeg",
    "https://cdn.faire.com/fastly/be54ebfcc731aa9fbfed569d317be8bcde023d0cbfd0bfa5af793b1cbe19014e.jpeg",
    "https://cdn.faire.com/fastly/ab34a030aa265a5e1f9a36b8372f5d10b046bfd9669b0dba14e522331c8296a9.jpeg",
    "https://cdn.faire.com/fastly/3eb821b098afae1c9b50d08856d9800568711d5bf5ffc39d6a8ef1e84a903449.jpeg",
    "https://cdn.faire.com/fastly/418270e811ff37c0a9dd05c458824c6c01787b67392dfe4920443956fff32446.jpeg",
    "https://cdn.faire.com/fastly/74c1d914487fbcc045dabde0f77813af690312ec84a55ed41e82aae2ceb84ba7.jpeg",
    "https://cdn.faire.com/fastly/edbed4f64640405772d2f6a56ba740a94c6aa9dd013a6f60fcec987a5db12996.jpeg",
    "https://cdn.faire.com/fastly/53f280ef36bbd12a1ae38aecdb9d012fbcd05e1952fccaeda3e287d590882324.jpeg",
    "https://cdn.faire.com/fastly/2f0d92b7a332804096b2cb4b739fe29bbdd2605104414f8af7b1db963d06f6e4.jpeg",
    "https://cdn.faire.com/fastly/6006ddb35a4942826f15cb9aa71192d71a2692de806040e9ac43f21a8b0266c0.jpeg",
    "https://cdn.faire.com/fastly/335c63b19a7c5883440351f93e5907a616893478eb4327047129a093a35f9e94.jpeg",
    "https://cdn.faire.com/fastly/fe00b359d8c791c5dad1365f9608f2c6bbae7877b307b11fab744e10743e7da6.jpeg",
    "https://cdn.faire.com/fastly/d99f118fd79b2e3d9327400b59cb8df01e9734a9b7268afbf98856ba02b69cd5.jpeg",
    "https://cdn.faire.com/fastly/40078c294ea049555b29aa9de9cc1160ee54e1e0c0ab8969f551b5eb342eefbf.jpeg",
    "https://cdn.faire.com/fastly/54dfb4008f07f481a047c497713eca0bb72338e6b6f9a44498a8fbf86e1a3e49.jpeg",
    "https://cdn.faire.com/fastly/41d27d2558b1bfb751d08a6a2b16bdbd15bb1194e6d80c09dbcf7ff6e96553c7.jpeg",
    "https://cdn.faire.com/fastly/f17aae8353f4aca1160b2f75206f8b3e09065c2a079f8937dbd79d3a39a5d0e4.jpeg",
  ],
  priceDollars: 10.16,
  description:
    "Beautiful soft to touch retro print scarf on cashmere blend fabric. Scarf is finished with fringes and comes in 6 colour variations\n\nComposition and Size:\nL: 180cm x W: 70cm\n20% Cashmere and 80% Acrylic \nWeight approx: 320 grams\n\nPlease note:\nThe actual colour of the items may appear different from the picture shown on the website due to different screen settings, camera lights or personal vision ability. Please contact us if you have any questions.",
  tags: [],
  msrpDollars: 33.79,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:51.484Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
